import {
  MUNICIPALLEVELMANAGELIST} from 'actions/municipalLevelManage';
import {reducerPackage} from "../../utils";
//问题
export const municipalLevelManageList = reducerPackage(MUNICIPALLEVELMANAGELIST);

